const propertyDetailAdapter = (data: any) => {
  const leadRefererInfo = prepareLeadData(data);
  return {
    leadRefererInfo,
  } as PropertyDetailAdapterReturn;
};
export default propertyDetailAdapter;

const prepareLeadData = (data: any) => {
  let params = new URL(data.url).searchParams;
  const referer = params.get("referer");
  const areferer = params.get("areferer");
  const isReferer = Boolean(referer || areferer);

  return {
    propertyId: data.id,
    isReferer: isReferer || false,
    isAgenciesReferer: Boolean(areferer) || false,
    isAgentReferer: Boolean(referer) || false,
    codeReferer: referer || areferer || null,
  } as PropertyDetailAdapterReturn["leadRefererInfo"];
};

export interface PropertyDetailAdapterReturn {
  leadRefererInfo: {
    propertyId: number;
    isReferer: boolean;
    isAgenciesReferer: boolean;
    isAgentReferer: boolean;
    codeReferer: number | null;
  };
}
